;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/YoutubeVideo',["jquery", "eventManager", 'loglevel', "//www.youtube.com/iframe_api"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel'), require("//www.youtube.com/iframe_api")) :
    console && console.error('TabSet does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function YoutubeVideo(scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer) {
        ///<summary>Initialize a new instance of YoutubeVideo. Subscribe to messages which are passed to current instance.</summary>

        var self = this, instance = {};
        instance.stateChangeMessages = stateChangeMessages.slice();
        
        Object.defineProperties(this, {
            scope: {enumerable: !0, value: scope},
            $scope: { enumerable: true, value: $(scope) },
            stateChangeMessages: {
                enumerable: true,
                get: function () {
                    return instance.stateChangeMessages.slice();
                }
            },
            trackTimelineInterval: {
                enumerable: !1,
                value: void 0,
                writable: !0,
            },
            currentTime: {
                enumerable: !1,
                get: function() {
                    return this.player ? Math.floor(this.player.getCurrentTime()) : void 0;
                }
            },
            isInteractedWithUser: { enumerable: true, configurable: true, writable: true, value: false }
        });
        
        this.addStateChangeMessage = function addStateChangeMessage(message) {
            if (!message) return;
            if (instance.stateChangeMessages.indexOf(message) > -1) {
                log.debug("Component is already registered for event " + message);
                return;
            }
            
            instance.stateChangeMessages.push(String(message));
        };

        //#region play message performer
        if (onPlayMessagesPerformer.length) {
            onPlayMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.play, self);
            });
        }
        //#endregion

        //#region show messages performer
        if (onPauseMessagePerformer.length) {
            onPauseMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pause, self);
            });
        }
        //#endregion

        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }

        YT.ready(function () {
            var videoId = self.$scope.find('iframe').attr('id');

            Object.defineProperties(self, {
                videoId: { enumerable: true, value: videoId },
                player: { enumerable: false, value: new YT.Player(videoId) }
            });

            self.player.addEventListener("onStateChange", self._playerStateChange.bind(self));

            // Pause all Youtube videos except one passed in the 'event' parameter and when user has already interacted with it
            eventManager.subscribe("stopYT", function (event, targetIsInteractedWithUser) {
                var target = event.target;
                if (self.player.getIframe() !== target.getIframe() && targetIsInteractedWithUser) {
                    self.player.pauseVideo();
                }
            });
        });
    }

    YoutubeVideo.prototype._playerStateChange = function(e) {

        switch (e.data) {
            case YT.PlayerState.ENDED:
                this.stopTrackTimeline();
                $(this).trigger('end.video', [this.currentTime]);
                this.isInteractedWithUser = true;
                break;
            case YT.PlayerState.PLAYING:
                //if (this.currentTime === 0) {
                    $(this).trigger('start.video', [this.currentTime]);
                //}
                eventManager.trigger("stopYT", e, this.isInteractedWithUser);
                $(this).trigger('update.timeline', [this.currentTime]);
                this.startTrackTimeline();
                this.isInteractedWithUser = true;
                break;
            case YT.PlayerState.PAUSED:
                this.stopTrackTimeline();
                $(this).trigger('pause.video', [this.currentTime]);
                this.isInteractedWithUser = true;
                break;
        }

        this.transmitStateChange.apply(this, arguments);
    }

    YoutubeVideo.prototype.startTrackTimeline = function() {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }

        this.trackTimelineInterval = setInterval((function () {
            $(this).trigger('update.timeline', [this.currentTime]);
        }).bind(this), 1000 /* 1 second */);

        $(this).trigger('update.timeline', [this.currentTime]);
    }

    YoutubeVideo.prototype.stopTrackTimeline = function() {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }

        $(this).trigger('update.timeline', [this.currentTime]);
    }

    YoutubeVideo.prototype.play = function () {
        ///<summary>Start playing the video.</summary>
        this.isInteractedWithUser = false;

        // According to Youtube IFrame API documentation, embedded media cannot be played automatically in Chrome and Safari.
        // https://developers.google.com/youtube/iframe_api_reference#Autoplay_and_scripted_playback
        // We can play embedded media via API in muted state only or when user has already interacted with the player.
        if (this.player && typeof this.player.mute === "function") {
            this.player.mute().playVideo();
        }

        this.transmitStateChange();
    }

    YoutubeVideo.prototype.pause = function () {
        ///<summary>Put the video on pause.</summary>
        if (this.player && typeof this.player.pauseVideo === "function") {
            this.player.pauseVideo();
        }

        this.transmitStateChange();
    }

    YoutubeVideo.prototype.transmitStateChange = function () {
        var messages = this.stateChangeMessages, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self, self.player);
            });
        }
    }
    // #endregion

    YoutubeVideo.init = function init(args) {
        if (args.IsEditorEditing) return null;

        var video = new YoutubeVideo(args.scope,
            args.StateChangeMessagesTransmitting || [],
            args.PlayActionMessages || [],
            args.PauseActionMessages || []);

        return video;
    };

    return YoutubeVideo;
}));
